<template>
	<div class="body">
		<el-container>
			
			<el-header>
				<HeaderCus></HeaderCus>
			</el-header>
			
			<el-main>
				<div class="content_main">
					<div class="mbxdh">
						<el-breadcrumb separator-class="el-icon-arrow-right">
						  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
						  
						  <el-breadcrumb-item :to="{ path: '/list_biaogan'}">标杆企业</el-breadcrumb-item>
						  
						  <!-- <el-breadcrumb-item v-if="daqu == 1">大区A</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="daqu == 2">大区B</el-breadcrumb-item> -->
						  <!-- <el-breadcrumb-item v-if="tuwen_type == 43">知识产权工具</el-breadcrumb-item>
						  <el-breadcrumb-item v-if="tuwen_type == 45">知识产权案例</el-breadcrumb-item> -->
						  
						</el-breadcrumb>
					</div>
					
					<div class="nrqy">
						
						<el-row class="tiaojian_elrow" style="margin-top: -10px;">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按地区：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_prov_type[0]" @click="clickDiqu(0, 0)">不限</el-tag>
									<el-dropdown size="small" placement="top-end" @command="selectProv">
										<span class="el-dropdown-link">
											{{prov_text}}<i class="el-icon-arrow-down el-icon--right"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="0">不限省份</el-dropdown-item>
											<el-dropdown-item v-for="(item, index) in list_prov" :key="index" :command="item.id">
												{{item.name}}
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
									<el-dropdown size="small" placement="top-end" @command="selectCity">
										<span class="el-dropdown-link">
											{{city_text}}<i class="el-icon-arrow-down el-icon--right"></i>
										</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item command="0">不限地市</el-dropdown-item>
											<el-dropdown-item v-for="(item, index) in list_city" :key="index" :command="item.id">
												{{item.name}}
											</el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>
								</div>
							</el-col>
						</el-row>
						
						
						<el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按领域：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_lingyu_type[0]" @click="clickLingyu(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_lingyu" :key="index" :type="list_lingyu_type[index+1]" @click="clickLingyu(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						
						<el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按年份：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_year_type[0]" @click="clickYear(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_year" :key="index" :type="list_year_type[index+1]" @click="clickYear(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						<el-row class="tiaojian_elrow" v-show="is_show_month">
							<el-col :span="2" :push="1">
								<div class="tiaojian_line_row_left" style="font-size: 13px;">
									按月份：
								</div>
							</el-col>
							<el-col :span="20" :push="1">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_month_type[0]" @click="clickMonth(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_month" :key="index" :type="list_month_type[index+1]" @click="clickMonth(index+1, item.dictValue)">{{item.dictLabel}}</el-tag>
								</div>
							</el-col>
						</el-row>
						
						<el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按模块：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_daqu_type[0]" @click="clickDaqu(0, 0)">不限</el-tag>
									<el-tag type="info" size="small" v-for="(item, index) in list_daqu" :key="index" :type="list_daqu_type[index+1]" @click="clickDaqu(index+1, item.id)">{{item.name}}</el-tag>
								</div>
							</el-col>
						</el-row>
						<el-row class="tiaojian_elrow" v-show="is_show_mokuai">
							<el-col :span="2" :push="1">
								<div class="tiaojian_line_row_left" style="font-size: 13px;">
									二级模块：
								</div>
							</el-col>
							<el-col :span="20" :push="1">
								<div class="tiaojian_line_row_right">
									<el-tag size="small" :type="list_mokuai_type[0]" @click="clickMokuai(0, 0)">不限</el-tag>
									<el-tag size="small" v-for="(item, index) in list_mokuai" :key="index" :type="list_mokuai_type[index+1]" @click="clickMokuai(index+1, item.id)">{{item.name}}</el-tag>
								</div>
							</el-col>
						</el-row>
						
						<!-- <el-row class="tiaojian_elrow">
							<el-col :span="2">
								<div class="tiaojian_line_row_left">
									按其它：
								</div>
							</el-col>
							<el-col :span="21">
								<div class="tiaojian_line_row_right">
									<el-tag size="small">其它123</el-tag>
									<el-tag size="small">其它456</el-tag>
								</div>
							</el-col>
						</el-row> -->
						
						<el-row class="tiaojian_elrow" style="border: 0px;">
							<el-col :span="21" :push="1">
								<div class="tiaojian_line_row_right">
									<el-input
										placeholder="请输入关键词搜索..."
										prefix-icon="el-icon-search"
										style="width: 40%;"
										v-model="keyword"
										:clearable="true"
										@clear="clearInput"
										>
									</el-input>
									
									<el-dropdown @command="selectSearchType">
									  <el-button plain size="medium">
									    {{search_type}}<i class="el-icon-arrow-down el-icon--right"></i>
									  </el-button>
									  <el-dropdown-menu slot="dropdown">
									    <el-dropdown-item v-for="(item, index) in list_search_type" :command="item.val">{{item.text}}</el-dropdown-item>
									  </el-dropdown-menu>
									</el-dropdown>
									
									<el-button type="primary" size="medium" @click="doSearch" v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>
									<span class="span_search_result">检索到{{total}}条数据</span>
								</div>
							</el-col>
						</el-row>
						
					</div>
					
					<div class="neirong_line">
						<div class="neirong_line_left">
							
							<el-empty description="没找到你想要的数据..." v-show="is_show_empty"></el-empty>
							
							<div class="neirong_line_region" v-for="(item, index) in list_record">
								<div class="neirong_line_title" @click="toDetail(item.id, item.daquId, item.mokuaiId)">
									<div class="neirong_line_title_icon"></div>
									{{item.name}}
									<span v-show="item.daquName != null">【{{item.daquName}}】</span>
									<span v-show="item.mokuaiName != null">[{{item.mokuaiName}}]</span>
								</div>
								<!-- <div class="neirong_line_summary">
									{{item.summary}}
								</div> -->
								<div class="neirong_line_option">
									<el-row>
										<el-col :span="4">
											&nbsp;
											<!-- <el-button icon="el-icon-star-off" size="mini"> 加入收藏 </el-button> -->
										</el-col>
										<el-col :span="4" :offset="12">
											<el-button icon="el-icon-document" size="mini" style="float: right;" @click="toDetailSigle(item.id, 'wd_detail')"> 问询与答复 </el-button>
										</el-col>
										<el-col :span="4">
											<el-button icon="el-icon-data-analysis" size="mini" style="float: right;" @click="toDetailSigle(item.id, 'bg_detail')"> 企业详情 </el-button>
										</el-col>
									</el-row>
								</div>
								<div class="neirong_line_split"></div>
							</div>
							
							
							<div class="neirong_line_page">
								<el-pagination
								  background
								  layout="prev, pager, next, jumper"
								  :page-size="9"
								  :total="total"
								  @current-change="handlePage"
								  >
								</el-pagination>
							</div>
							
						</div>
						
						
						<div class="neirong_line_right">
							<AdverRightCus></AdverRightCus>
						</div>
					</div>
					
				</div>
			</el-main>
			
			<el-footer>
				<FooterCus></FooterCus>
			</el-footer>
			
		</el-container>
	</div>
</template>

<script>
	import HeaderCus from '../components/header.vue'
	import FooterCus from '../components/footer.vue'
	import AdverRightCus from '../components/adverRight.vue'
	export default {
		components: {
			HeaderCus,
			FooterCus,
			AdverRightCus,
		},
		data() {
			return {
				daqu: 0,
				mokuai: 0,
				
				list_prov: [],
				list_city: [],
				list_prov_type: ['primary', ],
				
				list_lingyu: [],
				list_lingyu_type: ['primary', ],
				
				list_year: [],
				list_year_type: ['primary', ],
				
				is_show_month: false,
				list_month: [],
				list_month_type: ['primary', ],
				
				list_daqu: [],
				list_daqu_type: ['primary', ],
				is_show_mokuai: false,
				list_mokuai: [],
				list_mokuai_type: ['primary', ],
				
				is_show_empty: false,
				daqu_id: 0, // 大区id
				mokuai_id: 0, // 模块id
				prov_text: '选择省份', // 用户选择的省份名
				city_text: '选择地市', // 用户选择的城市名
				prov_val: 0, // 用户选择的省份值
				city_val: 0, // 用户选择的城市值
				lingyu_val: 0, // 用户选择的领域
				year_val: 0, //用户选择的年份
				month_val: 0, // 用户选择的月份
				keyword: '', // 搜索关键词
				list_record: [], // 数据列表
				pi: 1, // 当前页码
				total: 0, //数据总数
				
				fullscreenLoading: false,
				
				search_type: '企业名称',
				list_search_type: [{val:0, text: '企业名称'}, {val:1, text: '正文内容'}],
				
				
			}
		},
		
		created() {
			this.daqu = sessionStorage.getItem('daqu') // 从sessionstorage中获取
			this.mokuai = sessionStorage.getItem('mokuai') // 从sessionstorage中获取
			if (this.daqu > 0) {
				console.log('大区：' + this.daqu)
			} else {
				this.daqu = 0
			}
			if (this.mokuai > 0) {
				console.log('模块：' + this.mokuai)
			} else {
				this.mokuai = 0
			}
			console.log('URL大区：' + this.daqu, 'URL大区模块：' + this.mokuai)
			
			let trigger = this.$route.query.trigger
			// console.log(trigger)
			if (trigger == 'sch') {
				this.keyword = this.$route.query.kw
				let st = this.$route.query.st
				if (st == 0) {
					this.search_type = '企业搜索'
				} else {
					this.search_type = '全文检索'
				}
			}
			
		},
		
		mounted() {
			this.$router.beforeEach((to, from, next) => {
				// console.log(to, from)
				if (to.meta.title) {
					document.title = to.meta.title
				}
				next()
			})
			
			this.loadDictLingyu()
			this.loadDictYear()
			this.loadDictMonth()
			this.loadProv()
			// this.loadCity('37') // 点击省份后触发加载城市
			this.loadDaqu()
			// this.loadMokuai('1') // 点击大区触发加载模块
			
			if (this.daqu == 0 && this.mokuai == 0) {
				this.doSearch(1) // 加载列表数据
			} else if (this.daqu > 0 && this.mokuai == 0) {
				this.loadDaquAuto(this.daqu) // url传值中有大区，没模块
			} else if (this.daqu > 0 && this.mokuai > 0) {
				this.loadMokuaiAuto(this.daqu, this.mokuai) // url传值中有大区也有模块
			}
		},
		
		methods: {
			// web配置数据链接跳转
			toUrl(url) {
				// console.log(url)
				if (url.indexOf('http') > -1) {
					location.href = url
				} else {
					// this.$router.push({path: url})
					let route_data = this.$router.resolve({path: url})
					// console.log(route_data)
					window.open(route_data.href, '_blank')
				}
			},
			
			// 标杆企业专用跳转详情页（标杆企业搜索结果跳转不同数据集，所以不用toUrl()单独写一个toDetail()方法）
			toDetail(com_id, daqu_id, mokuai_id) {
				console.log('com_id:' + com_id, 'daqu_id:' + daqu_id, 'mokuai_id:' + mokuai_id)
				if (daqu_id == 0 && mokuai_id == 0) {
					let url = '/detail_company?id=' + com_id + '&tozgs=zgszcg' // 跳转到招股说明书注册稿的参数
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				} else if (daqu_id == 0 && mokuai_id > 0) {
					// 注意这里daqu_id和mokuai_id做了换位处理，具体业务细节回头再考虑
					let url = '/detail_company_prosp_sp?comid=' + com_id + '&moduleid=' + mokuai_id
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				} else if (daqu_id > 0 && mokuai_id > 0) {
					let url = '/detail_company_prosp_sp?comid=' + com_id + '&moduleid=' + mokuai_id
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				}
			},
			
			// 跳转企业详情或企业问询答复列表
			toDetailSigle(com_id, label) {
				if (label == 'bg_detail') {
					let url = '/detail_company?id=' + com_id
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				} else if (label == 'wd_detail') {
					let url = '/detail_wenda_list?id=' + com_id
					let route_data = this.$router.resolve({path: url})
					window.open(route_data.href, '_blank')
				}
			},
			
			// 加载搜索数据，flag约定传值1或-1，flag为标记是否第1页，传1则第1页，传-1则不改变翻页值（使用已有第x页的值）
			doSearch(flag) {
				this.fullscreenLoading = true
				this.list_record = [] // 先设置成空有个视觉切换效果
				if (flag == 1) {
					this.pi = 1
				}
				let url = this.$common.apiUrl + 'pub_company_base/clientSearch'
				let client_data_json = {
					daqu_id: this.daqu_id,
					mokuai_id: this.mokuai_id,
					prov: this.prov_val,
					city: this.city_val,
					lingyu: this.lingyu_val,
					year: this.year_val,
					month: this.month_val,
					keyword: this.keyword,
					pi: this.pi,
					search_type: this.search_type
				}
				let client_data = this.$qs.stringify(client_data_json)
				this.$axios.post(url, client_data).then((res)=>{
					console.log(res.data)
					this.fullscreenLoading = false
					this.list_record = res.data.data.rows
					this.total = res.data.data.total
					if (this.list_record == 0) {
						this.is_show_empty = true
					} else {
						this.is_show_empty = false
					}
				})
				
				this.clearSessionStorageDaquMokuai() // 清空sessionstorage中的数据
			},
			
			// 清空搜索框时
			clearInput() {
				if (this.keyword == '') {
					this.doSearch(1)
				}
			},
			
			// 点击分页触发事件
			handlePage(page) {
				// console.log(page)
				this.pi = page
				this.doSearch(-1)
				document.documentElement.scrollTop = 0;
			},
			
			// 加载字典数据（行业领域）
			loadDictLingyu() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_hangyelingyu'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_lingyu = res.data.data
					// 绑定样式数组
					this.list_lingyu.forEach((item, index) => {
						this.list_lingyu_type.push('info')
					})
				})
			},
			
			// 加载字典数据（年份）
			loadDictYear() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_apply_year'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_year = res.data.data
					// 绑定样式数组
					this.list_year.forEach((item, index) => {
						this.list_year_type.push('info')
					})
				})
			},
			
			// 加载字典数据（月份）
			loadDictMonth() {
				let url = this.$common.apiUrl + 'sys_dict_data/listByType/pub_dict_apply_month'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_month = res.data.data
					// 绑定样式数组
					this.list_month.forEach((item, index) => {
						this.list_month_type.push('info')
					})
				})
			},
			
			// 加载省份
			loadProv() {
				let url = this.$common.apiUrl + 'pub_region/listProv'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_prov = res.data.data
				})
			},
			
			// 加载地市
			loadCity(provid) {
				let url = this.$common.apiUrl + 'pub_region/listCity/' + provid
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_city = res.data.data
				})
			},
			
			// 加载模块大区
			loadDaqu() {
				let url = this.$common.apiUrl + 'pub_company_module/listDaqu'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_daqu = res.data.data
					// 绑定样式数组
					this.list_daqu.forEach((item, index) => {
						this.list_daqu_type.push('info')
					})
				})
			},
			
			// 加载模块大区-自动赋值（有传参的情况）(只实现了业务，逻辑不够好，时间宽裕另行处理)
			loadDaquAuto(id) {
				let url = this.$common.apiUrl + 'pub_company_module/listDaqu'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_daqu = res.data.data
					// 绑定样式数组
					this.list_daqu.forEach((item, index) => {
						this.list_daqu_type.push('info')
					})
					
					// console.log(this.list_daqu)
					this.list_daqu.forEach((item, index) => {
						if (id == item.id) {
							this.$set(this.list_daqu_type, index+1, 'primary')
						} else {
							this.$set(this.list_daqu_type, 0, 'info')
							this.$set(this.list_daqu_type, index+1, 'info')
						}
					})
					this.daqu_id = id
					if (id == 0) {
						this.is_show_mokuai = false
						this.mokuai_id = 0
					} else {
						this.loadMokuaiAuto(id, 999999) // 加载大区下的模块
						this.is_show_mokuai = true
					}
					
					this.doSearch(1)
				})
			},
			
			// 加载二级模块
			loadMokuai(daquid) {
				let url = this.$common.apiUrl + 'pub_company_module/listMokuai/' + daquid
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_mokuai = res.data.data
					// 绑定样式数组
					this.list_mokuai.forEach((item, index) => {
						this.list_mokuai_type.push('info')
					})
				})
			},
			
			// 加载二级模块-自动赋值（有传参的情况）(只实现了业务，逻辑不够好，时间宽裕另行处理)
			loadMokuaiAuto(daquid, mokuaiid) {
				let url = this.$common.apiUrl + 'pub_company_module/listDaqu'
				this.$axios.get(url).then((res)=>{
					// console.log(res)
					this.list_daqu = res.data.data
					// 绑定样式数组
					this.list_daqu.forEach((item, index) => {
						this.list_daqu_type.push('info')
					})
					
					// console.log(this.list_daqu)
					this.list_daqu.forEach((item, index) => {
						if (daquid == item.id) {
							this.$set(this.list_daqu_type, index + 1, 'primary')
						} else {
							this.$set(this.list_daqu_type, 0, 'info')
							this.$set(this.list_daqu_type, index + 1, 'info')
						}
					})
					this.daqu_id = daquid
					if (daquid == 0) {
						this.is_show_mokuai = false
						this.mokuai_id = 0
					} else {
						// 加载大区下的模块
						// console.log('加载大区下的模块进行业务处理', this.is_show_mokuai)
						this.is_show_mokuai = true
						let url = this.$common.apiUrl + 'pub_company_module/listMokuai/' + daquid
						this.$axios.get(url).then((res)=>{
							// console.log(res)
							this.list_mokuai = res.data.data
							// 绑定样式数组
							this.list_mokuai.forEach((item, index) => {
								this.list_mokuai_type.push('info')
							})
							
							this.list_mokuai.forEach((item, idx)=>{
								if (mokuaiid == item.id) {
									this.$set(this.list_mokuai_type, idx + 1, 'primary')
								} else {
									this.$set(this.list_mokuai_type, 0, 'info')
									this.$set(this.list_mokuai_type, idx + 1, 'info')
								}
							})
							
							if (mokuaiid == 999999) {
								this.mokuai_id = 0
							} else {
								this.mokuai_id = mokuaiid
								this.doSearch(1) // 传递特殊标记，只有在id不等于999999时重新加载数据
							}
							
						})
					}
					
					// this.doSearch(1)
				})
				
				
			},
			
			// 选择省份
			selectProv(command) {
				// console.log(command)
				if (command == 0) {
					this.prov_val = 0
					this.prov_text = '选择省份'
					this.$set(this.list_prov_type, 0, 'primary')
				} else if (command > 0) {
					this.list_prov.forEach((item, index) => {
						if (item.id == command) {
							// console.log(item.name);
							this.prov_val = item.id
							this.prov_text = item.name
							this.loadCity(this.prov_val) // 加载下级城市
							this.$set(this.list_prov_type, 0, 'info')
							this.city_val = 0
							this.city_text = '选择城市'
						}
					})
				}
				
				this.doSearch(1)
			},
			
			// 选择城市
			selectCity(command) {
				if (command == 0) {
					this.city_val = 0
					this.city_text = '选择城市'
				} else if (command > 0) {
					this.list_city.forEach((item, index) => {
						if (item.id == command) {
							// console.log(item.name);
							this.city_val = item.id
							this.city_text = item.name
						}
					})
				}
				
				this.doSearch(1)
			},
			
			// 点击地区条件（这个略特殊，只有“不限”按钮触发）
			clickDiqu(index, id) {
				if (index == 0) {
					this.$set(this.list_prov_type, 0, 'primary')
					this.prov_val = 0
					this.prov_text = '选择省份'
					this.city_val = 0
					this.city_text = '选择城市'
				}
				
				this.doSearch(1)
			},
			
			// 点击领域条件
			clickLingyu(index, id) {
				console.log(index, id)
				this.list_lingyu_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_lingyu_type, idx, 'primary')
					} else {
						this.$set(this.list_lingyu_type, idx, 'info')
					}
				})
				this.lingyu_val = id
				
				this.doSearch(1)
			},
			
			// 点击时间条件（年）
			clickYear(index, id) {
				// console.log(index, id)
				this.list_year_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_year_type, idx, 'primary')
					} else {
						this.$set(this.list_year_type, idx, 'info')
					}
				})
				this.year_val = id
				
				if (index == 0) {
					this.is_show_month = false
					this.month_val = 0
				} else {
					this.is_show_month = true
					this.clickMonth(0, 999999)
				}
				
				this.doSearch(1)
			},
			
			// 点击月份条件（月）
			clickMonth(index, id) {
				// console.log(index, id)
				this.list_month_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_month_type, idx, 'primary')
					} else {
						this.$set(this.list_month_type, idx, 'info')
					}
				})
				
				if (id == 999999) {
					this.month_val = 0
				} else {
					this.month_val = id
					this.doSearch(1) // 传递特殊标记，只有在id不等于999999时重新加载数据
				}
			},
			
			// 点击大区条件
			clickDaqu(index, id) {
				// console.log(index, id)
				this.list_daqu_type.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_daqu_type, idx, 'primary')
					} else {
						this.$set(this.list_daqu_type, idx, 'info')
					}
				})
				this.daqu_id = id
				
				if (index == 0) {
					this.is_show_mokuai = false
					this.mokuai_id = 0
				} else {
					this.loadMokuai(id) // 加载大区下的模块
					this.is_show_mokuai = true
					this.clickMokuai(0, 999999)
				}
				
				this.doSearch(1)
			},
			
			// 点击二级模块条件
			clickMokuai(index, id) {
				// console.log(index, id)
				this.list_mokuai.forEach((item, idx)=>{
					if (index == idx) {
						this.$set(this.list_mokuai_type, idx, 'primary')
					} else {
						this.$set(this.list_mokuai_type, idx, 'info')
					}
				})
				
				if (id == 999999) {
					this.mokuai_id = 0
				} else {
					this.mokuai_id = id
					this.doSearch(1) // 传递特殊标记，只有在id不等于999999时重新加载数据
				}

			},
			
			// 清除临时存储的sessionstorage的大区和模块
			clearSessionStorageDaquMokuai() {
				sessionStorage.setItem('daqu', 0)
				sessionStorage.setItem('mokuai', 0)
			},
			
			// 选择搜索类型
			selectSearchType(command) {
				// console.log(command)
				if (command == 0) {
					this.search_type = '企业名称';
				} else if (command == 1) {
					this.search_type = '正文内容';
				}
			},
			
			
		}
	}
</script>

<style scoped>
.el-dropdown-link {
	cursor: pointer;
	color: #409EFF;
}
.el-icon-arrow-down {
	font-size: 12px;
}
.el-tag--small {
	margin: 0 10px;
}
.el-dropdown {
	margin: 0 10px;
}
</style>